export const servicesData = [
  {
    id: 1,
    title: {
      number: "1",
      mainTitle: "Residential Solar",
    },
    imageUrl: "/home/7.png",
    heading: "Switch to Solar and Save Big on Energy Bills",
    description:
      "At Satyanam Solar, we specialize in providing efficient and cost-effective solar solutions for homeowners. With increasing electricity costs and a growing focus on sustainability, solar energy is the perfect choice for your home. Our residential solar installations are designed to meet the unique energy needs of each household, ensuring maximum energy production while reducing your carbon footprint.",
    keySpecifications: [
      "Customized Solar Solutions",
      "Seamless Installation Process",
      "Energy Savings",
      "Long-Term Reliability",
    ],
  },

  {
    id: 2,
    title: {
      number: "2",
      mainTitle: "Commercial Solar",
    },
    imageUrl: "/home/6.png",
    heading: "Boost Your Business with Solar Energy",
    description:
      "Businesses today are not just focused on profits—they are also increasingly committed to sustainability. Satyanam Solar provides tailored solar solutions for commercial establishments, helping companies reduce energy costs while embracing renewable energy. Whether you are a small business or a large corporation, we offer scalable solutions to meet your energy needs.",
    keySpecifications: [
      "Tailored Commercial Systems",
      "Reduced Operating Costs",
      "Scalable Solutions",
      "Tax Incentives and Rebates",
    ],
  },

  {
    id: 3,
    title: {
      number: "3",
      mainTitle: "Housing Society Solar",
    },
    imageUrl: "/home/8.png",
    heading: "High-Capacity Solar for Housing Societies",
    description:
      "Transform your housing society into a green, energy-efficient community with Satyanam Solar’s comprehensive solar solutions. We understand the unique challenges that housing societies face when it comes to energy management. Our team offers efficient, shared solar installations that can power multiple households and reduce energy costs for the entire community.",
    keySpecifications: [
      "Shared Solar Solutions",
      "Cost-Effective Energy Sharing",
      "Sustainable Living",
      "Ease of Management",
    ],
  },

  {
    id: 4,
    title: {
      number: "4",
      mainTitle: "Carport Mounting Structures",
    },
    imageUrl: "/home/Carport.png",
    heading: "The Smart Solar Solution for Parking Spaces",
    description:
      "Maximize space and generate green energy with our innovative carport mounting structures. These structures serve a dual purpose—providing shaded parking for vehicles while supporting high-efficiency solar panels to generate clean electricity. Whether for residential, commercial, or industrial use, our solar carports are designed to maximize energy output while offering a sleek and practical parking solution.",
    keySpecifications: [
      "Efficient Use of Space",
      "Protection for Vehicles",
      "Sustainable Energy Generation",
      // "Customizable & Scalable Solutions",
      "Cost Savings & ROI",
    ],
  },
];